import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useRelated(type, id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    async function fetchRelated() {
      setLoading(true);
      const { response, data } = await API.fetchRelated(token, type, id);

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    if (type && id) {
      fetchRelated();
    }
  }, [type, id]);

  return {
    loading,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
};
